import React from 'react'

const Spacer = ({ height = 50 }) => {
    return (
        <div className="bg-transparent" style={{ 'height': `${height}vh` }}></div>
    )
}

export default Spacer
